import Vuex from 'vuex'
import { actions, mutations, state } from './comum'
import acessosistema from './acessosistema'
import contaContabil from './conta-contabil'
import patrimonio from './patrimonio'
import amortizacao from './amortizacao'
import relatorio from './relatorio'
import CamposPersonalizados from './camposPersonalizados'
import movimentacao from './movimentacao'
import dashboard from './dashboard'
import fundos from './fundos'
import fonteFinanciamento from './fonte-financiamento'
import projeto from './projeto'
import reavaliacao from './reavaliacao'
import documento from './documento'
import relatorioTce from './relatoriotce'
import parametros from './configuracao/parametros'
import ajuste from './ajuste'


export default new Vuex.Store({
    state,
    mutations,
    actions,
    modules: {
        acessosistema,
        contaContabil,
        patrimonio,
        amortizacao,
        relatorio,
        CamposPersonalizados,
        movimentacao,
        dashboard,
        fundos,
        fonteFinanciamento,
        projeto,
        reavaliacao,
        documento,
        relatorioTce,
        parametros,
        ajuste,
    }
})
